import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart6: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chart-6, statistics, graph"><path d="M18 3.00098C16.8954 3.00098 16 3.89641 16 5.00098V19.5H14.5V10.501C14.5 9.39641 13.6046 8.50098 12.5 8.50098H11.5C10.3954 8.50098 9.5 9.39641 9.5 10.501V19.5H8V16.001C8 14.8964 7.10457 14.001 6 14.001H5C3.89543 14.001 3 14.8964 3 16.001V19.5H1.75C1.33579 19.5 1 19.8358 1 20.25C1 20.6642 1.33579 21 1.75 21H22.25C22.6642 21 23 20.6642 23 20.25C23 19.8358 22.6642 19.5 22.25 19.5H21V5.00098C21 3.89641 20.1046 3.00098 19 3.00098H18Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChart6;
